// react
import React from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const DailyPredictions = (props) => {

    return (
            <Container style={{}}>
                <Row>
                    {/*}
                    <Col xs={3}>
                        <img src={analytics} width={60} />
                    </Col>*/}
                    <Col>
                    {/*
                    <Label>Booking Forecast</Label>
                        <div style={{}}>
                        {
                            status == 'loading' ?
                            <Spinner
                                as="span"
                                animation="border"
                                size="xs"
                                role="status"
                                aria-hidden="true"
                                variant='primary'
                                style={{}}
                            />  
                            :
                            <p style={{fontWeight:'300'}}>{monthlyPrediction == 0 ? 'Unavailable' : monthlyPrediction.toLocaleString() + ' Expected Passengers'}</p>
                        }
                        </div>
                        */}
                    </Col>
                </Row>
            </Container>
    );
}

export default DailyPredictions;